const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: '',
  title: 'Xavier King',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Xanny',
  role: 'Back End Engineer',
  description: `Goal-oriented full stack developer with hands-on experience in building web and mobile applications with the latest information technology. Highly adept in teamwork and cooperation style working to make a great contribution to company's success. As for personal characteristics, thrive on challenge and work well under the fast-paced, highly-pressure environment.`,
  resume:
    'https://drive.google.com/file/d/1uHXa9N0s9fhLUwhro8Afy7GUivvGrrsu/view?usp=drive_link',
  social: {
    linkedin: 'https://linkedin.com/in/xavier-taoking',
    github: 'https://github.com/devgod611',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'invideo AI',
    img: '/assets/images/Invideo.png',
    // description:
    //   'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: [
      'Tensorflow',
      'PyTorch',
      'TTS engine',
      'Lumen 5',
      'Pandas',
      'NumPy',
    ],
    // sourceCode: 'https://github.com',
    livePreview: 'https://invideo.io/',
    company: 'invideo',
    year: 'Jan/2023 ~ Aug/2024',
  },
  {
    name: 'Thetanuts',
    img: '/assets/images/thenutsfinance.png',
    // description:
    //   'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['Node.js', 'Python', 'Solidity', 'Restful API'],
    // sourceCode: 'https://github.com',
    livePreview: 'https://thetanuts.finance',
    company: 'Thetanuts',
    year: 'Jan/2021 ~ Jan/2023',
  },
  {
    // name: 'Senior Fullstack engineer',
    name: 'Accellor',
    img: '/assets/images/Accellor.png',
    // description:
    //   'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: [
      'React',
      'Next.js',
      'Node.js',
      'GraphQL',
      'Restful API',
      'PostgreSQL',
    ],
    // sourceCode: 'https://github.com',
    livePreview: 'https://accellor.com',
    company: 'Accellor',
    year: 'Jan/2020 ~ Dec/2020',
  },
  {
    // name: 'Backend engineer',
    name: 'Exante',
    img: '/assets/images/exante.png',
    // description:
    //   'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['Backbone.js', 'Particle.js', 'Python', 'Rest API'],
    // sourceCode: 'https://github.com',
    livePreview: 'https://exante.eu',
    company: 'Exante',
    year: 'Jan/2019 ~ Dec/2019',
  },
  {
    // name: 'Frontend and Mobile engineer',
    name: 'Liftango',
    img: '/assets/images/liftango.png',
    // description:
    //   'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
    stack: ['React', 'React Native', 'Node.js', 'Restful API', 'MySQL'],
    // sourceCode: 'https://github.com',
    livePreview: 'https://www.liftango.com/',
    company: 'Liftango',
    year: 'Jan/2018 ~ Oct/2018',
  },
  {
    name: 'Memories',
    img: '/assets/images/memories.png',
    // description:
    //   ` •	Simple page navigation and main page \n
    // •	Report submits as PDF and make them downloadable`,
    stack: ['React', 'Redux', 'Sass', 'Typescript'],
    // sourceCode: 'https://github.com',
    livePreview: 'https://memories.com.au',
    company: 'lifelongmemories',
    year: '2016',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'JavaScript',
  'TypeScript',
  'React',
  'Redux',
  'SASS',
  'Vue',
  'Nuxt.js',
  'Tailwind CSS',
  'Angular',
  'Node.js/Express',
  'Python/Django',
  'Java/Spring',
  'MongoDB',
  'GraphQL',
  'AWS',
  'Gatsby.js',
  'Jest',
  'Cypress',
  'Web3.js',
  'Linux/Unix Docker',
  'AEM',
  'Jenkins',
  'Microservice',
  'python',
  'AI',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'kingxanny88@outlook.com',
}

export { header, about, projects, skills, contact }
